export default __webpack_public_path__ + "static/banner-mobile-66e15538118504695aa252d1f4858520.svg";